module.exports = __webpack_public_path__ + "static/media/to-the-end-page.1b39601f.svg";